import { render, staticRenderFns } from "./PreCaseUploadSelector.vue?vue&type=template&id=4e4fb484&scoped=true&"
import script from "./PreCaseUploadSelector.vue?vue&type=script&lang=js&"
export * from "./PreCaseUploadSelector.vue?vue&type=script&lang=js&"
import style0 from "./PreCaseUploadSelector.vue?vue&type=style&index=0&id=4e4fb484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4fb484",
  null
  
)

export default component.exports